<template>
  <span>
    {{ displayValue }}
  </span>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'DateTimeValue',
  props: ['value'],
  computed: {
    displayValue () {
      if (this.value) {
        let dt = dayjs(this.value)
        return dt.format('MM/DD/YYYY HH:mm')
      }
      return ''
    }
  }
}
</script>
